var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('p',[_vm._v("\n    "+_vm._s(_vm.$t('school.academic.operation.classOperation.teacher_same_confirmation'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }